import { Component, inject } from '@angular/core';
import { DateTime } from 'luxon';
import {
    Animations,
    BackendOberflaecheService,
    BeitragComponent, GoogleTagManagerService,
    OberflaecheElement,
    OberflaecheSeite,
    OberflaecheWerteEintrag,
    OberflaecheWerteResponse,
    RateService
} from '@vhv/tarifrechner-common';


@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: 'baugeraete-beitrag.component.html',
})
export class BaugeraeteBeitragComponent extends BeitragComponent {

    public zusaetzlicheAbsicherung: boolean;
    public feuerrisiko: boolean;
    public minderertragsdeckung: boolean;
    public laufzeitElement: OberflaecheElement;
    public minVersicherungsbeginn: string;
    private responseJson: OberflaecheWerteResponse;

    private ausgefuellteWerte: any;
    private laufzeitWerte: any;
    public laufzeitHinweisText: OberflaecheElement;

    googleTagManagerService: GoogleTagManagerService = inject(GoogleTagManagerService)
    constructor(
        private _inputBackendOberflaecheService: BackendOberflaecheService,
        private _rateService: RateService,
    ) {
        super();
        this.googleTagManagerService.sendPriceListEvent();
    }

    async initialiseSeite() {
        this._inputBackendOberflaecheService.getOberflaeche().then((value: OberflaecheSeite[]) => {
            this._inputBackendOberflaecheService.getElementByName('Zahlweise').value = '1';
        });
        super.initialiseSeite();
        await this.asyncFunctions();
    }

    private async asyncFunctions() {
        try {
            this.responseJson = await this._inputBackendOberflaecheService.getOberflaecheWerteP('LaufzeitWerte', []);
            this.laufzeitWerte = this.responseJson.werte.map(element => {
                return {
                    'anzeige': element.anzeige,
                    'inhalt': element.inhalt,
                };
            });

            this.setOberflaecheElemente(this.laufzeitWerte);
        } catch (error) {
            console.log(error);
        }
    }

    private setOberflaecheElemente(response: any) {
        this.ausgefuellteWerte = this._inputBackendOberflaecheService.getAusgefuellteWerte();
        this.zusaetzlicheAbsicherung = false;
        if (this.ausgefuellteWerte['FeuerMitVersichern'] === 'true') {
            this.feuerrisiko = true;
            this.zusaetzlicheAbsicherung = true;
        }
        if (this.ausgefuellteWerte['Minderertragsversicherung'] === 'true') {
            this.minderertragsdeckung = true;
            this.zusaetzlicheAbsicherung = true;
        }
        for (const element of this.currentSeite.elemente) {
            if ('Laufzeit' === element.name) {
                this.laufzeitElement = element;
                this.laufzeitElement.oberflaecheWerteEintraege = response;
                if (!this.laufzeitElement.value) {
                    this.laufzeitElement.value = "3";
                    this._inputBackendOberflaecheService.getElementByName("Vertragslaufzeit").value = this.laufzeitElement.value;
                }
            }
            if ('LaufzeitHinweisText' === element.name) {
                this.laufzeitHinweisText = element;
            }
        }
        this.minVersicherungsbeginn = this.getMinVersicherungsbeginn();
        this.setVersicherungsAblaufOptionsUndBerechne();
    }

    protected onChange(value: string): void {
        super.onChange(value);
        this.laufzeitElement.value = value;
    }

    getVertragsbeginn(): DateTime {
        return DateTime.fromFormat(this.getVersicherungsbeginn(), 'dd.MM.yyyy');
    }

    setVersicherungsAblaufOptionsUndBerechne(): void {
        this.berechneBeitraegeNeu();
        const werte: OberflaecheWerteEintrag[] = [];
        const laufzeitOptions: number[] = [1, 3];
        for (let i = 0; i < this.laufzeitElement.oberflaecheWerteEintraege.length; i++) {
            let versicherungsAblauf = this.getVertragsbeginn();
            versicherungsAblauf = versicherungsAblauf.plus({years: laufzeitOptions[i]});
            werte.push(new OberflaecheWerteEintrag(versicherungsAblauf.toFormat('dd.MM.yyyy'), laufzeitOptions[i].toString()));
        }
        this.laufzeitElement.oberflaecheWerteEintraege = werte;
    }

    versicherungsablaufChange(): void {
        this._inputBackendOberflaecheService.getElementByName("Vertragslaufzeit").value = this.laufzeitElement.value;
        this.changeLaufzeitHinweisTextVisible(this.laufzeitElement.value);
        this.berechneBeitraegeNeu();
    }

    changeLaufzeitHinweisTextVisible(laufzeit: string): void {
        this.laufzeitHinweisText.attribut.sichtbarkeit = "immer";

        if (laufzeit === "1") {
            this.laufzeitHinweisText.attribut.sichtbarkeit = "hidden";
        }
    }

    berechneBeitraegeNeu(): void {
        this._rateService.calculateBeitrag();
        this._rateService.getBeitrag().then(value => {
            this.beitragsdaten.getValue().gesamtJahresNettoBeitrag = value.gesamtJahresNettoBeitrag;
            this.beitragsdaten.getValue().gesamtJahresBruttoBeitrag = value.gesamtJahresBruttoBeitrag;
        }).catch(error => {
            console.log('Beitrag kann nicht ermittelt werden: ' + error);
        });
    }
}
